import { Controller } from "stimulus";
import Tribute from "tributejs";
import Trix from "trix";

const SEARCH_DEBOUNCE_MS = 175;

export default class extends Controller {
  static targets = [ "field" ]

  connect() {
    this.searchTimers = {}
    this.searchControllers = {}
    this.lastMentionSearchErrorAt = 0
    this.replaced = this.replaced.bind(this)

    this.tributes = [
      this.buildTribute({ values: this.searchValues("/business/mentions/users.json") }),
      this.buildTribute({ trigger: '#', values: this.searchValues("/business/mentions/clients.json") }),
      this.buildTribute({ trigger: '##', values: this.searchValues("/business/mentions/pets.json") })
    ]

    this.fieldTarget.addEventListener("tribute-replaced", this.replaced)
  }

  disconnect() {
    this.tributes.forEach(tribute => {
      tribute.detach(this.fieldTarget)
      if (tribute.menu) tribute.menu.remove()
    })
    this.fieldTarget.removeEventListener("tribute-replaced", this.replaced)
    Object.values(this.searchTimers).forEach(timer => clearTimeout(timer))
    Object.values(this.searchControllers).forEach(controller => controller.abort())
  }

  get editor() {
    return this.fieldTarget.editor
  }

  buildTribute(options) {
    let tribute = new Tribute({
      allowSpaces: true,
      lookup: 'name',
      selectTemplate: item => (item ? "" : null),
      ...options
    })
    tribute.attach(this.fieldTarget)
    tribute.range.pasteHtml = this._pasteHtml.bind(this)
    return tribute
  }

  searchValues(endpoint) {
    return (text, callback) => {
      clearTimeout(this.searchTimers[endpoint])
      this.searchTimers[endpoint] = setTimeout(() => {
        this.performSearch(endpoint, text, callback)
      }, text ? SEARCH_DEBOUNCE_MS : 0)
    }
  }

  performSearch(endpoint, text, callback) {
    if (this.searchControllers[endpoint]) {
      this.searchControllers[endpoint].abort()
    }

    let abortController = new AbortController()
    this.searchControllers[endpoint] = abortController

    fetch(`${endpoint}?query=${encodeURIComponent(text)}`, { signal: abortController.signal })
      .then(response => {
        if (!response.ok) throw new Error("Mention search request failed");
        return response.json();
      })
      .then(results => callback(results))
      .catch(error => {
        if (error.name === "AbortError") return;
        callback([]);
        this.notifyMentionSearchUnavailable();
      })
      .finally(() => {
        if (this.searchControllers[endpoint] === abortController) {
          delete this.searchControllers[endpoint]
        }
      })
  }

  notifyMentionSearchUnavailable() {
    if (Date.now() - this.lastMentionSearchErrorAt < 5000) return;
    this.lastMentionSearchErrorAt = Date.now();

    if (window.notyf) {
      window.notyf.error("Mention search is temporarily unavailable. Please try again in a moment.");
    }
  }

  _pasteHtml(html, startPos, endPos) {
    let range = this.editor.getSelectedRange()
    let position = range[0]
    let length = endPos - startPos

    this.editor.setSelectedRange([position - length, position])
    this.editor.deleteInDirection("backward")
  }

  replaced(e) {
    let mention = e.detail.item.original
    let attachment = new Trix.Attachment({
      sgid: mention.sgid,
      content: mention.content
    })
    this.editor.insertAttachment(attachment)
    this.editor.insertString(" ")
  }
}
